import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetWhatsNewFeedLastUpdatedTimeQueryVariables = Types.Exact<{
  locale?: Types.InputMaybe<Types.SupportedLocale>;
}>;


export type GetWhatsNewFeedLastUpdatedTimeQuery = { __typename?: 'Query', whatsNewFeed?: { __typename?: 'WhatsNewFeed', lastUpdated?: string | null } | null };


export const GetWhatsNewFeedLastUpdatedTime = /*#__PURE__*/ gql`
    query GetWhatsNewFeedLastUpdatedTime($locale: SupportedLocale) {
  whatsNewFeed(locale: $locale) {
    lastUpdated
  }
}
    ` as unknown as DocumentNode<GetWhatsNewFeedLastUpdatedTimeQuery, GetWhatsNewFeedLastUpdatedTimeQueryVariables>;

          

          export const useGetWhatsNewFeedLastUpdatedTimeQuery = (options?:QueryHookOptions<GetWhatsNewFeedLastUpdatedTimeQuery, GetWhatsNewFeedLastUpdatedTimeQueryVariables>) => useQuery(GetWhatsNewFeedLastUpdatedTime, options);

          

          export type GetWhatsNewFeedLastUpdatedTimeQueryOptions = QueryHookOptions<GetWhatsNewFeedLastUpdatedTimeQuery, GetWhatsNewFeedLastUpdatedTimeQueryVariables>;

          

          export const useGetWhatsNewFeedLastUpdatedTimeLazyQuery = (options?:LazyQueryHookOptions<GetWhatsNewFeedLastUpdatedTimeQuery, GetWhatsNewFeedLastUpdatedTimeQueryVariables>) => useLazyQuery(GetWhatsNewFeedLastUpdatedTime, options);

          

          export type GetWhatsNewFeedLastUpdatedTimeQueryResult = ReturnType<typeof useGetWhatsNewFeedLastUpdatedTimeQuery>;

          
